module.exports = __webpack_public_path__ + "img/codigo api correios 2.1d6ac5c3.png";